import React from "react";
import { DataTable } from "react-native-paper";
import { TableValueCellComponent } from "./Types";

export const TableUnsupportedTypeCell: TableValueCellComponent = ({
  field,
}) => {
  return <DataTable.Cell>{`Unsupported type: ${field.type}`}</DataTable.Cell>;
};
